module.exports = __webpack_public_path__ + "static/media/left_arrow.5fa49bec.svg";